module.exports = __webpack_public_path__ + "img/button_volna_an.28c3f5c9.svg";